import { errorLogService } from '@/services/api/errorLog.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { errorLogModel } from '@/models/api/errorLog.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    status: {
        list: true,
    },
};

export const ERROR_LOG_MODULE = "api/errorLog";

// ACTIONS
export const GET_ALL_ERROR_LOG = 'getAllErrorLog';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_ERROR_LOG_SUCCESS = "allErrorLogSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [GET_ALL_ERROR_LOG]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        errorLogService
            .getAll(filter)
            .then((result) => {
                commit(ALL_ERROR_LOG_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_ERROR_LOG_SUCCESS](state, {data}) {
        let errorLogList = data.data || [];
        state.list.data = errorLogList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = errorLogList.map(item => errorLogModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
        };
    },
};

